import React, {useState, useEffect} from 'react';
import DateTimePicker from './DateTimePricker';
import {format, fromUnixTime} from 'date-fns';
import {es} from 'date-fns/locale';
import { ReactComponent as IconoBorrar } from './../imagenes/borrar.svg';
import { ReactComponent as IconoOrdenar } from './../imagenes/ordenar.svg';
import {
	ContenedorSubtituloPequeño, ContenedorSubtitulo, Subtitulo, Lista, ElementoLista, ContenedorFiltros,Contenedor, Formulario,
	Input, ContenedorBoton,Btn, BotonAccion, ContenedorLista,ContenedorItinerario,ContenedorInputConIcono, ContenedorInputconLabel,BotonGuardaTraslados,BotonOrdenaItinerario
} from '../elementos/ElementosDeFormulario';
import Boton from './../elementos/Boton';
import {ReactComponent as IconoPlus} from './../imagenes/plus.svg';
import SelectClientes from './SelectClientes';
import SelectMoviles from './SelectMoviles';
import {db} from '../firebase/firebaseConfig';
import { ref, push, set, query, onValue,orderByChild,startAt,endAt } from "firebase/database";
import {ContenedorBotones} from '.././elementos/Header';
//import { ReactComponent as IconoEstado } from '.././imagenes/estado.svg';
//import { ReactComponent as IconoPasajero } from '.././imagenes/pasajero.svg';
import {ReactComponent as IconoDown} from './../imagenes/down.svg';
import {ReactComponent as IconoUp} from './../imagenes/up.svg';
import Iconotipo from '../elementos/IconoItinerario';
//import Alerta from './../elementos/Alerta';
import { useAuth } from './../contextos/AuthContext';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUser} from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import useObtenerAdmin from './../hooks/useObtenerViajes15minutos'
import SelectMoviles15 from './SelectMoviles15';


const FormularioViaje = ({viaje,itinerario, cambiarItinerario, listadoPasajeros, cambiarListadoPasajeros,fechahoraviaje, cambiarFechahoraviaje,cliente,cambiarCliente,cambiarVerFormularioViaje,Escliente,UsarioLog}) => {
    const {usuario} = useAuth();
    const [viajes15, cambiarViajes15] = useState([]);
    const [fecha_hora_creacion, cambiarfecha_hora_creacion] = useState (new Date());
    const [estado, cambiarEstado] = useState ('Programado');
    const [movil, CambiarMovil] = useState({numero:"Movil"});
    const [comentarios, CambiarComentarios] = useState('');
    const [folio, cambiarFolio] = useState('');
    const [kmfolio, cambiarKmfolio] = useState('');
    const [vuelo, cambiarVuelo] = useState('');
    const [muestraFolio, cambiarMuestraFolio] = useState(true);
    const [ordenado, CambiarOrdenado] = useState('');
//    const [alerta, cambiarAlerta] = useState({});
  //  const [estadoAlerta, cambiarEstadoAlerta] = useState(false);

   useEffect (()=>{
    viaje.empresa && cambiarCliente(viaje.empresa);
    viaje.numero_m && CambiarMovil({
        numero:  viaje.numero_m,
        color: viaje.color_m,
        nombre: viaje.nombre_m,
        patente: viaje.patente_m,
        telefono: viaje.telefono_m,
        tipo: viaje.tipo_m
    });
    viaje.fecha_hora_programada && cambiarFechahoraviaje(new Date(viaje.fecha_hora_programada));
    viaje.itinerario && cambiarItinerario(Object.keys(viaje.itinerario).map(function (key) {return {id : key, ...viaje.itinerario[key]};}))
    viaje.pasajeros && cambiarListadoPasajeros(Object.keys(viaje.pasajeros).map(function (key) {return {id : key, ...viaje.pasajeros[key]};}))
    viaje.comentarios && CambiarComentarios(viaje.comentarios);    
    viaje.estado && cambiarEstado(viaje.estado);
    viaje.fecha_hora_creacion && cambiarfecha_hora_creacion(new Date(viaje.fecha_hora_creacion));
    },[viaje]);

    function toTimestamp(strDate){
        var datum = Date.parse(strDate);
        return datum;
     }

    const BorrarPasajero = (TelefoPasajero) => {  
            const filtradositinerario = itinerario.filter(item => item.telefono !== TelefoPasajero)
            cambiarItinerario(filtradositinerario)
            const filtradosListadoPasajeros = listadoPasajeros.filter(item => item.telefono !== TelefoPasajero)
            cambiarListadoPasajeros(filtradosListadoPasajeros)
        }

    const Ordenar = () => {  
        
        itinerario.sort((a, b) => ((a.tipo) < (b.tipo) ? 1 : (a.tipo) > (b.tipo) ? -1 : 0))
        CambiarOrdenado(ordenado+'ordenado')
    }

    const Subir = (indexitinerario) => {  
        if(indexitinerario>0) {
            if(itinerario[indexitinerario].telefono!==itinerario[indexitinerario-1].telefono){
                const indexitinerarioa = itinerario[indexitinerario]
                const indexitinerariob = itinerario[indexitinerario-1]
                itinerario.splice(indexitinerario, 1, indexitinerariob);
                itinerario.splice(indexitinerario-1, 1, indexitinerarioa);
                CambiarOrdenado(ordenado+'ordenado')
            }else{
                Swal.fire({
                    title: 'Error de Orden',
                    text: 'El destino no puede estar antes del origen',
                    icon: 'error',
                    timer:2000
                    })
            }
       }else{
        Swal.fire({
            title: 'Error de Orden',
            text: 'No se puede subir el registro',
            icon: 'error',
            timer:2000
            })
          }
        } 

    const Bajar = (indexitinerario) => {  
        if(itinerario.includes(itinerario[indexitinerario+1])) {
            if(itinerario[indexitinerario].telefono!==itinerario[indexitinerario+1].telefono){
                const indexitinerarioa = itinerario[indexitinerario]
                const indexitinerariob = itinerario[indexitinerario+1]
                itinerario.splice(indexitinerario, 1, indexitinerariob);
                itinerario.splice(indexitinerario+1, 1, indexitinerarioa);
                CambiarOrdenado(ordenado+'ordenado')
            }else{
                Swal.fire({
                    title: 'Error de Orden',
                    text: 'El destino no puede estar antes del origen',
                    icon: 'error',
                    timer:2000
                    })
                }
          }else{
            Swal.fire({
                title: 'Error de Orden',
                text: 'No se puede bajar el registro',
                icon: 'error',
                timer:2000
                })
          }
    }

    const handleChange = (e) => {
		if(e.target.name === 'movil'){
			CambiarMovil(e.target.value);
		} else if (e.target.name === 'comentarios'){
			CambiarComentarios(e.target.value);
		} else if (e.target.name === 'folio'){
			cambiarFolio(e.target.value);
		} else if (e.target.name === 'kmfolio'){
			cambiarKmfolio(e.target.value);
		} else if (e.target.name === 'vuelo'){
			cambiarVuelo(e.target.value);
		}
	}

   useEffect (()=>{    
        if(movil.numero !== 'Movil')
        {cambiarEstado('Asignado');
    }
        else {cambiarEstado('Programado');};

    },[movil]);


    useEffect (()=>{    
        if(UsarioLog.hasOwnProperty("numero"))
        {CambiarMovil(UsarioLog)}
    },[]);

    useEffect (()=>{    
        if(cliente === 'METRO' || cliente === 'Metro' )
        {cambiarMuestraFolio(false);} else {cambiarMuestraFolio(true);} 
        if(UsarioLog.hasOwnProperty("numero"))
        {CambiarMovil(UsarioLog)}
    },[cliente]);


    const handleSubmit = async (e) => {
        e.preventDefault();

// valida viajes 
//const viajes15 = useObtenerViajes15minutos();

        var salir = false
        if(cliente === 'Seleccione Cliente' || cliente === undefined){
            await Swal.fire({
                title: 'Complete Información',
                text: 'Por favor selecciona cliente',
                icon: 'error',
                timer:2000
                })
			return;
		}

        if(fechahoraviaje === null){
            await Swal.fire({
                title: 'Complete Información',
                text: 'Seleccione fecha y hora de viaje',
                icon: 'error',
                timer:2000
                })
    		return;
		}
        if(Escliente===true){
            var date = new Date()
            var numberOfMlSeconds = date.getTime();
            var addMlSeconds4 = 60 * 60000 * 4; // 4 horas de programacion
            var addMlSeconds1 = 60 * 60000; // 4 horas de programacion
            var cuatrohoras = new Date(numberOfMlSeconds + addMlSeconds4);
            var unahora = new Date(numberOfMlSeconds + addMlSeconds1);
            var hora = format(date, "HH'", {locale: es})
            //console.log(hora)
            //console.log(cuatrohoras)
            //console.log(fechahoraviaje)
            //console.log(Escliente)

            if(hora === "08" || hora === "09" || hora === "10" || hora === "11" || hora === "12" || hora === "13" || hora === "14" || hora === "15" || hora === "16" || hora === "17" || hora === "18" || hora === "19"){
                if(fechahoraviaje <= (new Date(unahora))){
                    await Swal.fire({
                        title: 'No se pudo agendar el traslado via web',
                        text: 'Favor considerar comunicarse vía telefónica +56 222221126 / 222225132 / 222223125 Móvil 961594201 o correo a central@radiotaxiestrella.cl, de no ser posible agendar un servicio.',
                        icon: 'error',
                        timer:20000
                        })
                    {salir = true};
                    }
            }else{
                if(fechahoraviaje <= (new Date(cuatrohoras))){
                    await Swal.fire({
                        title: 'No se pudo agendar el traslado via web cuatro',
                        text: 'Favor considerar comunicarse vía telefónica +56 222221126 / 222225132 / 222223125 Móvil 961594201 o correo a central@radiotaxiestrella.cl, de no ser posible agendar un servicio.',
                        icon: 'error',
                        timer:20000
                        })
                    {salir = true};
                    }                
            }

   
        }else{
            if(fechahoraviaje <= (new Date())){
                await Swal.fire({
                    title: 'Advertencia',
                    text: '¿Desea registrar un traslado con fecha anterior a la actual?',
                    icon: 'warning',
                    showDenyButton: true,
                    denyButtonText: 'No',
                    confirmButtonText: 'Si',
                    confirmButtonColor: "blue"
                    }).then(response => {
                        if(response.isDenied)
                        {salir = true}
                    } 
                    )
                }
        }
        if(salir===true){return;}


        if(itinerario.length === 0 || listadoPasajeros.length === 0){
            await Swal.fire({
                title: 'Complete Información',
                text: 'Seleccione pasajero para trasladar en la búsqueda lateral',
                icon: 'error',
                timer:2000
                })
			return;
		}



        if(movil.numero === 'Movil' || movil.numero === undefined){

          //  console.log(fechahoraviaje)
          //  console.log(toTimestamp(fechahoraviaje))
            
            const postListRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados');
            const newPostRef = push(postListRef);
            await set(newPostRef, {
                estado: estado,
                fecha_hora_programada: toTimestamp(fechahoraviaje),
                empresa: cliente,
                folio: folio,
                kmfolio: kmfolio,
                n_vuelo: vuelo,
                comentarios: comentarios,
                fecha_hora_creacion : toTimestamp(fecha_hora_creacion),
                fecha_hora_modificacion : toTimestamp(fecha_hora_creacion),
                creador : usuario.uid,
                modificador : usuario.uid
            }); 
            const opostListRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/'+newPostRef.key+'/pasajeros');
            await listadoPasajeros.map (pasajeroTraslado  =>{           
                const onewPostRef = push(opostListRef);
                set(onewPostRef, pasajeroTraslado)
            })
            const opostItitRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/'+newPostRef.key+'/itinerario');
            await itinerario.map (pasajeroitinerario  =>{           
                const onewPostRef = push(opostItitRef);
                set(onewPostRef, pasajeroitinerario)
            })
    

            await Swal.fire({
                title: 'Traslado Programado',
                text: 'El viaje fue creado sin Móvil, quedará en estado Programado',
                icon: 'success',
                timer:2000
                })
            cambiarVerFormularioViaje(true)
            cambiarItinerario([]);
            cambiarListadoPasajeros([]);
            cambiarCliente('Seleccione Cliente');
            cambiarEstado('Programado');
            CambiarMovil({numero:"Movil"});
            CambiarComentarios('');
            cambiarFechahoraviaje(null);



		} else {
           
            const postListRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados');
            const newPostRef = push(postListRef);
            await set(newPostRef, {
                estado: estado,
                fecha_hora_programada: toTimestamp(fechahoraviaje),
                numero_m: movil.numero,
                color_m: movil.color,
                nombre_m: movil.nombre,
                patente_m: movil.patente,
                telefono_m: movil.telefono,
                tipo_m: movil.tipo,
                empresa: cliente,
                folio: folio,
                kmfolio: kmfolio,
                n_vuelo: vuelo,
                comentarios: comentarios,
                fecha_hora_creacion : toTimestamp(fecha_hora_creacion),
                fecha_hora_modificacion : toTimestamp(fecha_hora_creacion),
                creador : usuario.uid,
                modificador : usuario.uid

            }); 

            const opostListRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/'+newPostRef.key+'/pasajeros');
            await listadoPasajeros.map (pasajeroTraslado  =>{           
                const onewPostRef = push(opostListRef);
                set(onewPostRef, pasajeroTraslado)
            })
            const opostItitRef = ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/'+newPostRef.key+'/itinerario');
            await itinerario.map (pasajeroitinerario  =>{           
                const onewPostRef = push(opostItitRef);
                set(onewPostRef, pasajeroitinerario)
            })

           
            await Swal.fire({
                title: 'Traslado Creado',
                text: 'El viaje fue creado con Móvil, quedará en estado Asignado',
                icon: 'success',
                timer:2000
                })
                cambiarVerFormularioViaje(true)
                cambiarItinerario([]);
                cambiarListadoPasajeros([]);
                cambiarCliente('Seleccione Cliente');
                cambiarEstado('Programado');
                CambiarMovil({numero:"Movil"});
                CambiarComentarios('');
                cambiarFechahoraviaje(null);
    }   

    }

    return (  
                
                    <Formulario onSubmit={handleSubmit}>
                        <Contenedor>
                        <main>   
                        
                        <ContenedorSubtitulo><Subtitulo>&nbsp;&nbsp;Datos de Traslado</Subtitulo></ContenedorSubtitulo>
                        
                        <ContenedorFiltros>
                        <ContenedorInputconLabel><p>Folio</p><Input name="folio" type="text" placeholder="-- " value={folio} onChange={handleChange} /></ContenedorInputconLabel>
                        <div hidden = {muestraFolio}>
                        <ContenedorInputconLabel><p>KMS</p><Input name="kmfolio" type="text" placeholder="--" value={kmfolio} onChange={handleChange}/></ContenedorInputconLabel>
                        </div> 
                        <ContenedorInputconLabel><p>Numero de Vuelo</p><Input name="vuelo" type="text" placeholder="--" value={vuelo} onChange={handleChange}/></ContenedorInputconLabel>
                        </ContenedorFiltros>
                                               
                        <ContenedorFiltros>
                        <div hidden={(UsarioLog.hasOwnProperty("numero"))}>
                        {!(Escliente) 
                      ? <ContenedorInputconLabel><p>Movil</p><SelectMoviles15 movil={movil} CambiarMovil={CambiarMovil} fechahoraviaje={fechahoraviaje}id={'nuevo'}/></ContenedorInputconLabel>
                      : <ContenedorInputconLabel><p>Movil</p><Input name="empresa" type="text" placeholder="Empresa" value={'Por Asignar'} disabled = {true}/></ContenedorInputconLabel>
                    
                    
                    }
                    </div>
                        
                    <div hidden={!(UsarioLog.hasOwnProperty("numero"))}>
                      <ContenedorInputconLabel><p>Movil</p><Input name="empresa" type="text" placeholder="Empresa" value={movil.numero} disabled = {true}/></ContenedorInputconLabel>
                    </div>

                        
                        {!(Escliente) 
                      ? <ContenedorInputconLabel><p>Cliente</p><SelectClientes cliente={cliente} cambiarCliente={cambiarCliente}/></ContenedorInputconLabel>
                      : <ContenedorInputconLabel><p>Cliente</p><Input name="empresa" type="text" placeholder="Empresa" value={cliente} disabled = {true}/></ContenedorInputconLabel>
                    }
                        
                        
                        
                        
                        
                        <ContenedorInputconLabel><p>Fecha-Hora</p><DateTimePicker fechahoraviaje={fechahoraviaje} cambiarFechahoraviaje={cambiarFechahoraviaje}/></ContenedorInputconLabel>
                        </ContenedorFiltros>

                        <ContenedorSubtitulo>
                            
                       
                            <Subtitulo>&nbsp;&nbsp;Itinerario de Viaje &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Subtitulo>   
                            <BotonOrdenaItinerario onClick={(e) => {e.preventDefault();Ordenar()}}> Ordenar Itinerario&nbsp;&nbsp;<IconoOrdenar fill="white"/></BotonOrdenaItinerario>
                            </ContenedorSubtitulo>
                        
                        <Lista>
                        {itinerario.map((pasajerol, index) =>{

                                return(
                                    
                                <ElementoLista key={pasajerol.id}>
                                    
                                    <ContenedorLista>
                                    
                                    <ContenedorItinerario>
                                    <ContenedorInputconLabel><p>Orden</p><Input name="orden_p" type="text" placeholder="Orden" value={index+1} disabled = {true}/></ContenedorInputconLabel>
                                    <ContenedorInputconLabel><p>Nombre Pasajero</p> <Input name="telefono_p" type="text" placeholder="Telefono Pasajero" value={pasajerol.nombre} disabled = {true}/> </ContenedorInputconLabel>
                                    <ContenedorInputconLabel><p>{pasajerol.tipo}</p><Input name="tipo_i" type="text" placeholder="Tipo Traslado" value={pasajerol.direccion} disabled = {true}/> </ContenedorInputconLabel>
                                    </ContenedorItinerario>

                                        <ContenedorBotones>
                                            <BotonAccion onClick={(e) => {
                                                e.preventDefault();
                                                BorrarPasajero(pasajerol.telefono)}}><IconoBorrar/></BotonAccion>
                                            <BotonAccion onClick={(e) => {
                                                e.preventDefault();
                                                Subir(index)}}><IconoUp/></BotonAccion>
                                            <BotonAccion onClick={(e) => {
                                                e.preventDefault();
                                                Bajar(index)}}><IconoDown/></BotonAccion>
                                        </ContenedorBotones>
                                    </ContenedorLista>
                                </ElementoLista>
                                )
                        })}
                        </Lista>                       

                        
                        </main>
                        
                        
                        <ContenedorSubtituloPequeño><Subtitulo>Comentarios</Subtitulo></ContenedorSubtituloPequeño>
                        <Input type="text" name="comentarios" placeholder="Comentarios"value={comentarios} onChange={handleChange}/>
                        <ContenedorBoton><BotonGuardaTraslados as="button" primario conIcono type="submit"> Guardar Traslado &nbsp;&nbsp;<IconoPlus/></BotonGuardaTraslados></ContenedorBoton>
                        
                        </Contenedor>
                        
                    </Formulario>
    );
}
 
export default FormularioViaje;